export class UpdateAdvisingDetailTaskRequest {
  adDetailSeqNo?: number
  taskCode?: string[]| null
  taskRemark: string | null
  createUser?: string
  updateUser?: string
  adNo?: string
  externLineNo?: string

  constructor(){
    this.adDetailSeqNo = undefined
    this.taskCode = undefined
    this.taskRemark = null
    this.createUser = undefined
    this.updateUser = undefined
    this.adNo = undefined
    this.externLineNo = undefined
  }
}
